<script>
import {defineComponent} from "vue";
import HeaderApp from "@/components/Header.vue";
import FooterApp from "@/components/Footer.vue";

export default defineComponent({
  components: {FooterApp, HeaderApp},
  name: 'DefaultApp'
})
</script>

<template>
  <div>
    <HeaderApp />
      <slot />
    <FooterApp />
  </div>
</template>

<style scoped>

</style>